import { getBasePath } from "./getBasePath.js";
let misc;

/** 运行时页面信息。*/

export function getPageInfo() {
  if (!misc) {
    misc = {
      isInIframe: false,
      isInIframeOfSameSite: false,
      isInIframeOfNext: false,
      isInIframeOfVisualBuilder: false,
      isInIframeOfLegacyConsole: false
    };
    if (window !== window.parent) {
      misc.isInIframe = true;
      try {
        // Handle:
        // - Previewing in visual builder by iframe.
        // - Nesting next in next.
        // - Nesting console in next.
        if (window.origin === window.parent.origin) {
          misc.isInIframeOfSameSite = true;
          const selfIsNext = getBasePath() === "/next/";
          const parentPathname = window.parent.location.pathname;
          const parentIsNext = parentPathname.startsWith("/next/");
          misc.isInIframeOfNext = (Number(selfIsNext) ^ Number(parentIsNext)) === 0;
          const prefix = parentIsNext ? "/next" : "";
          // Allow visual-builder-* extension apps.
          misc.isInIframeOfVisualBuilder = parentPathname.startsWith(`${prefix}/visual-builder/`) || parentPathname.startsWith(`${prefix}/visual-builder-`);
          misc.isInIframeOfLegacyConsole = selfIsNext && !parentIsNext;
        }
      } catch {
        // do nothing
      }
    }
    Object.freeze(misc);
  }
  return misc;
}
//# sourceMappingURL=getPageInfo.js.map